import React from 'react';

export default function LeftAlign() {
  return (
    <svg width="17" height="11" viewBox="0 0 17 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="-4.37114e-08" y1="0.5" x2="16.2857" y2="0.499999" stroke="#352830" />
      <line x1="-4.37114e-08" y1="10.5" x2="13.7143" y2="10.5" stroke="#352830" />
      <line x1="-4.37114e-08" y1="5.5" x2="10.2857" y2="5.5" stroke="#352830" />
    </svg>
  );
}
